import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { PlatformService } from './platform.service';

export function providePlatform(): EnvironmentProviders[] {
  return [
    provideAppInitializer(() => {
      const platformService = inject(PlatformService);

      platformService.initialize();
    }),
  ];
}
